import { jsx as l } from "react/jsx-runtime";
const n = (o) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ...o,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        d: "m9.548 8.401 3.674.029.344-.595-3.962-1.062A1.617 1.617 0 0 0 8.4 5.385v-.65L6.588 1.539h-.687l1.108 4.137a1.611 1.611 0 0 0-.592 1.585l-.555.32L4 10.748l.344.596 2.914-2.915-1.018 6.043h3.52L8.733 8.383c.13-.066.25-.15.356-.247l.458.264v.001Zm-2.125 5.072L8 10.048l.577 3.425H7.423ZM8.54 7.238a.614.614 0 0 1-.419.312l-.026.004a.613.613 0 1 1 .446-.316Z"
      }
    )
  }
);
export {
  n as WindPower
};
